"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayPaginationWithBasicItems", {
  enumerable: true,
  get: function get() {
    return _PaginationWithBasicItems.ClayPaginationWithBasicItems;
  }
});
exports.default = void 0;

var _Pagination = _interopRequireDefault(require("./Pagination"));

var _PaginationWithBasicItems = require("./PaginationWithBasicItems");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = _Pagination.default;
exports.default = _default;